import { getProductPage, getProductSideNav } from "../../../config/productContent.js";
import { buildAnimatedTitle } from "../../HeroTitleAnimation.js";
import { createHeroLogoMarquee } from "../../components/HeroLogoMarquee.js";

const checkIcon = `<svg class="hero__tag-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
  <path d="M2.5 7.5L5.5 10.5L11.5 3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export function createProductHeroSection() {
  const { hero } = getProductPage();
  const lanes = getProductSideNav();
  const laneLabels = lanes.map((lane) => lane.label);
  const section = document.createElement("section");
  section.id = "hero";
  section.className = "section hero product-hero";

  const shell = document.createElement("div");
  shell.className = "section__inner hero__shell";

  const grid = document.createElement("div");
  grid.className = "hero__grid product-hero__grid";

  grid.innerHTML = `
    <div class="hero__content">
      <h1 class="hero__title">${buildAnimatedTitle(hero.titleSegments)}</h1>
      <p class="hero__subtitle reveal">${hero.subtitle}</p>
      <div class="hero__actions reveal">
        <a class="btn btn--primary" href="${hero.ctaPrimaryHref}">${hero.ctaPrimary}</a>
        <a class="btn btn--ghost" href="${hero.ctaSecondaryHref}">${hero.ctaSecondary}</a>
      </div>
      <ul class="hero__tags reveal">
        ${hero.tags.map((tag) => `<li class="hero__tag">${checkIcon}${tag}</li>`).join("")}
      </ul>
    </div>

    <aside class="product-hero__panel reveal" style="--delay: 0.18s" aria-hidden="true">
      <div class="product-hero__panel-glow"></div>
      <div class="product-hero__panel-chrome">
        <span></span><span></span><span></span>
        <strong>product.lanes / overview</strong>
      </div>
      <div class="product-hero__panel-body">
        <p class="product-hero__panel-kicker">Active lane</p>
        <h2>${laneLabels.join(" → ")}</h2>
        <p>Scroll the showcase below. Each service stays pinned on the left while capability cards cycle two at a time.</p>
        <ul class="product-hero__lanes">
          ${laneLabels
            .map((label, index) => `<li${index === 0 ? ' class="is-on"' : ""}>${label}</li>`)
            .join("")}
        </ul>
      </div>
    </aside>
  `;

  shell.append(grid, createHeroLogoMarquee());
  section.append(shell);
  return section;
}
